import '../../../../vendor/ng-file-upload/ng-file-upload';

export const ngFileUploadComponentModule = 'ngFileUpload';
